import apiClient from './apiClient';

const merchantsService = {
  // Get all merchants (users with role='merchant')
  getMerchants: async () => {
    const response = await apiClient.get('/users');
    return response.data;
  },
  
  // Get single merchant
  getMerchant: async (id) => {
    const response = await apiClient.get(`/users/${id}`);
    return response.data;
  },
  
  // Create merchant
  createMerchant: async (data) => {
    const response = await apiClient.post('/users', { ...data, role: 'merchant' });
    return response.data;
  },
  
  // Update merchant
  updateMerchant: async (id, data) => {
    const response = await apiClient.put(`/users/${id}`, data);
    return response.data;
  },
  
  // Delete merchant
  deleteMerchant: async (id) => {
    const response = await apiClient.delete(`/users/${id}`);
    return response.data;
  }
};

export default merchantsService;